import { render, staticRenderFns } from "./nav-small.vue?vue&type=template&id=0d74c1ac&"
import script from "./nav-small.vue?vue&type=script&lang=js&"
export * from "./nav-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports